import { render } from "./PageDetailQualites.vue?vue&type=template&id=247c1e12&scoped=true"
import script from "./PageDetailQualites.vue?vue&type=script&lang=js"
export * from "./PageDetailQualites.vue?vue&type=script&lang=js"

import "./PageDetailQualites.vue?vue&type=style&index=0&id=247c1e12&scoped=true&lang=css"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247c1e12"]])

export default __exports__